// placeholder broker name for listings without a named human broker; never shown as a broker card or filter option
const AGENT_LANDERZ_BROKER_NAME = "Agent Landerz"

// maps broker full names as stored in HubSpot to their title key
// used for both primary and collaborative brokers in BrokerCard
// for collaborative brokers, only names listed here will be shown, others are silently excluded
export const BROKER_TITLES: Record<string, string> = {
	"Agent Landerz": "opportunities.broker_title",
	"Anthony Fayle": "opportunities.broker_title",
	"Antoine Talbot": "opportunities.broker_title",
	"Claudia Fofuca": "opportunities.broker_title",
	"Gabriel Trempe": "opportunities.broker_title",
	"Jessica Hockhoussen": "opportunities.broker_title",
	"Josua St-Pierre Labbé": "opportunities.broker_title",
	"Léopold Guillaume": "opportunities.broker_title",
	"Louis Palson": "opportunities.bdr_title",
	"Marc-Kamal Jabbour": "opportunities.broker_title",
	"Mathieu-Alexandre Gagnon": "opportunities.broker_title",
	"Maxime Beloeil": "opportunities.broker_title",
	"Robert MacDougall": "opportunities.broker_title",
	"Simon Boyer": "opportunities.broker_title",
	"Simon G. Boyer": "opportunities.broker_title",
	"Sylvain Bernèche": "opportunities.broker_title",
	"Yannick Therrien": "opportunities.broker_title",
}

// true for named human brokers only; excludes the Agent Landerz placeholder from broker cards and filters
export function isRealBroker(name: string | null | undefined): name is string {
	return !!name && name !== AGENT_LANDERZ_BROKER_NAME && name in BROKER_TITLES
}
